exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".firma-kart-report-table[data-v-1d84aee9]{width:100%;margin-top:4px}.firma-kart-report-table>*[data-v-1d84aee9]{width:100%}.firma-kart-action-cell[data-v-1d84aee9]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}", ""]);

// exports
